'use strict'

import React from 'react';

import Translations from '../../app/utils/translations.js';
/*
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);
*/

export default class ReleaseImplementationMethod extends React.Component {
  constructor(props) {
    super(props);
    this.state={method:"product",projects:props.projects};
  }

  loadProjects() {
    if (this.state.projects===undefined) {
      this.setState({pending:true});
      fetch("/projects/"+(this.props.product.portfolio!==undefined ? "?portfolio="+this.props.product.portfolio : ""))
        .then(response=>response.json())
        .then(projects=>{
          this.setState({projects:projects, panding:false})
        })
        .catch(error=>{
            console.log("[ERROR] Not able to load projects, got"+error);
            alert("An error occured while fetching existing projects, please try again");
          });
      }
  }

  submit(event) {
    event.preventDefault();
    console.log("Set implementation method to: "+event.target.elements.method.value);
    this.props.onChange(event.target.elements.method.value,event.target.elements.implementationProject!==undefined ? event.target.elements.implementationProject.value : undefined);
  }

  setProductMethod(event) {
    this.setState({method:"product"});
  }

  setProjectMethod(event) {
    this.setState({method:"project"});
    this.loadProjects();
  }

  render() {
    return (
      <form onSubmit={this.submit.bind(this)}>
        <h2>Select Release Implementation Method</h2>
        <i>
          A release can be implemented in a permanent product team using Product
          Management/Ownership as method, or it can be implemented as part of a
          project using Project Management as method.
        </i>
        <div style={{display:"flex", justifyContent:"space-around", paddingTop: 20}}>
          <div style={{backgroundColor:this.state.method==="product" ? "lightblue" : undefined, borderRadius:10, padding:10}}>
            <input onChange={this.setProductMethod.bind(this)} type="radio" name="method" value="product" defaultChecked={true} id="product"/>
            <span> </span>
            <label htmlFor="product" style={{fontWeight: this.state.method==="product" ? "bold" : undefined}}>Product Management</label>
            <div style={{fontStyle:"italic", paddingTop:15}}>
              Use Product Management if
              <ul>
                {[
                  {
                    title:"The team needed is co-located, small and permanent"
                  },
                  {
                    title:"Context is straight forward",
                    items: [
                      "Few stakeholders",
                      "Few interfaces",
                      "Matching competency"
                    ]
                  },
                  {
                    title:"There is high degree of certainty",
                    items: [
                      "Clarity in scope",
                      "High stakeholder risk apatite",
                      "Technology is well understood"
                    ]
                  }
                ].map(item=>(
                  <li>
                    {item.title}{item.items!==undefined ? (
                      <ul>{item.items.map(item=><li>{item}</li>)}</ul>
                    ): null}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div style={{backgroundColor: this.state.method==="project" ? "lightblue" : undefined, borderRadius:10, padding:10}}>
            <input onChange={this.setProjectMethod.bind(this)} ref="projectMethod" type="radio" name="method" value="project" id="project"/>
            <span> </span>
            <label htmlFor="project" style={{fontWeight:this.state.method==="project" ? "bold" : undefined}}>Project Management</label>
            <div style={{display:this.state.method==="project" ? undefined : "none", paddingTop: 5}}>
              <b>Select project:</b> <br/>
              {this.state.projects!==undefined ? (
                <select name="implementationProject">
                  <option>(select existing project)</option>
                  {this.state.projects.map(project=>(
                    <option value={project.id}>{project.name}</option>
                  ))}
                </select>
              ) : this.state.pending ? (
                <span style={{border: "solid 1px red", padding:1}}><i>Loading projects, please wait ...</i></span>
              ) : (
                <span>No projects available, please <a href="/add">add project</a> first</span>
              )}
            </div>
            <div style={{fontStyle:"italic", paddingTop:15}}>
              Use Project Management if
              <ul>
                {[
                  {
                    title: "A team is needed that is",
                    item:[
                      "Temporary",
                      "Large",
                      "Spread across functions or sites"
                    ]
                  },
                  {
                    title: "Context is complex",
                    items: [
                      "Many stakeholders",
                      "Many interfaces",
                      "Low matching competency"
                    ]
                  },
                  {
                    title: "There is a degree of uncertainty",
                    items: [
                      "Unclarity in scope",
                      "Low stakeholder risk apatite",
                      "Technology is not well understood"
                    ]
                  }
                ].map(item=>(
                  <li>
                    {item.title}{item.items!==undefined ? (
                      <ul>{item.items.map(item=><li>{item}</li>)}</ul>
                    ): null}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div style={{paddingTop:15}}>
          <input type="submit" className="save" value="Make Release Active"/>
          <a href="#" onClick={this.props.onCancel}>Cancel</a>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./views/product/ReleaseImplementationMethod.jsx